import React, { Component, Fragment} from 'react';
import {connect} from 'react-redux';

import './WebsiteHome.Module.scss';


import Modal from 'react-responsive-modal';


import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { faBolt, faChevronLeft, faCode, faHeart, faUsers, faUser, faClock, faCut, faDownload, faArrowToBottom } from '@fortawesome/pro-solid-svg-icons';

import {faHeart as faHeartRegular,} from '@fortawesome/pro-regular-svg-icons';

import{ faTimes as faTimesLight} from '@fortawesome/pro-light-svg-icons';

/**
 * import components
 */

import WebsiteFooter from 'components/UI/WebsiteFooter/WebsiteFooter';
import WebsiteHeader from 'components/UI/WebsiteHeader/WebsiteHeader';


import indexBlock from 'actions/block/index';
import indexLesson from 'actions/lesson/index';
import indexPage from 'actions/page/index';

import Homeblock from '../../components/UI/HomeBlock/Homeblock';

const mapStateToProps = (state, props) => {
    return {
        lessons: state.lesson.entities,
        blocks: state.block.entities
    };
};

const mapDispatchToProps = {
    indexBlock,
    indexLesson,
    indexPage
};

class WebsiteHome extends Component {

    constructor() {
        super();
        this.state = {
            mobileView: true,
        }
        this.handleResize   = this.handleResize.bind(this);
    }

    componentDidMount() {
        this.handleResize()
        window.addEventListener("resize", this.handleResize);

        if(this.props.match.params.versionId) {
            this.props.indexBlock(this.props.match.params.versionId);
        } else {
            this.props.indexBlock(null);            
        }
        this.props.indexPage();
        this.props.indexLesson();

    }

    handleResize(){
        let mobileViewCheck = window.innerWidth < 1100 ? true : false;
        this.setState({
            mobileView: mobileViewCheck
        });
    }


    render() {
        return (
            <Fragment>
                <div styleName='page'>
                    <div styleName='top'>
                        <WebsiteHeader/>
                        <div styleName='grid'>
                            {
                                this.props.blocks.allIds.map(function(blockId, i){
                                    let item = this.props.blocks.byId[blockId];
                                    if(this.state.mobileView){
                                        if(item.show_mobile){
                                            return(
                                                <Fragment>
                                                    <Homeblock 
                                                        item={item}
                                                        mobileView={this.state.mobileView}
                                                    />
                                                </Fragment>
                                            );
                                        } else{
                                            return
                                        }
                                    } else{
                                         return(
                                            <Fragment>
                                                <Homeblock 
                                                    item={item}
                                                />
                                            </Fragment>
                                        );
                                    }
                                }, this)
                            }
                        </div>
                    </div>
                    <WebsiteFooter/>
                </div>
            </Fragment>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WebsiteHome);